var exports = {
  "container": "SettingsModalLayout.module__container___RlRoUD",
  "containerFullscreen": "SettingsModalLayout.module__containerFullscreen___RlRoUD",
  "desktopSidebar": "SettingsModalLayout.module__desktopSidebar___RlRoUD",
  "desktopSidebarInner": "SettingsModalLayout.module__desktopSidebarInner___RlRoUD",
  "sidebarNavWrapper": "SettingsModalLayout.module__sidebarNavWrapper___RlRoUD",
  "sidebarNav": "SettingsModalLayout.module__sidebarNav___RlRoUD",
  "sidebarNavList": "SettingsModalLayout.module__sidebarNavList___RlRoUD",
  "sidebarFooter": "SettingsModalLayout.module__sidebarFooter___RlRoUD",
  "desktopScroll": "SettingsModalLayout.module__desktopScroll___RlRoUD",
  "desktopScrollInner": "SettingsModalLayout.module__desktopScrollInner___RlRoUD",
  "desktopContent": "SettingsModalLayout.module__desktopContent___RlRoUD",
  "desktopContentPad": "SettingsModalLayout.module__desktopContentPad___RlRoUD",
  "desktopContentCard": "SettingsModalLayout.module__desktopContentCard___RlRoUD",
  "desktopHeader": "SettingsModalLayout.module__desktopHeader___RlRoUD",
  "sidebarHeader": "SettingsModalLayout.module__sidebarHeader___RlRoUD",
  "sidebarNavContent": "SettingsModalLayout.module__sidebarNavContent___RlRoUD",
  "sidebarCategory": "SettingsModalLayout.module__sidebarCategory___RlRoUD",
  "sidebarCategoryTitle": "SettingsModalLayout.module__sidebarCategoryTitle___RlRoUD",
  "sidebarItem": "SettingsModalLayout.module__sidebarItem___RlRoUD",
  "sidebarItemSelected": "SettingsModalLayout.module__sidebarItemSelected___RlRoUD",
  "sidebarItemFocused": "SettingsModalLayout.module__sidebarItemFocused___RlRoUD",
  "sidebarItemDanger": "SettingsModalLayout.module__sidebarItemDanger___RlRoUD",
  "sidebarItemIcon": "SettingsModalLayout.module__sidebarItemIcon___RlRoUD",
  "sidebarItemLabel": "SettingsModalLayout.module__sidebarItemLabel___RlRoUD",
  "srOnly": "SettingsModalLayout.module__srOnly___RlRoUD",
  "externalTabLabel": "SettingsModalLayout.module__externalTabLabel___RlRoUD",
  "externalTabLabelText": "SettingsModalLayout.module__externalTabLabelText___RlRoUD",
  "externalTabIcon": "SettingsModalLayout.module__externalTabIcon___RlRoUD",
  "sidebarItemTrailing": "SettingsModalLayout.module__sidebarItemTrailing___RlRoUD",
  "sidebarItemAttentionDot": "SettingsModalLayout.module__sidebarItemAttentionDot___RlRoUD",
  "sidebarItemChevron": "SettingsModalLayout.module__sidebarItemChevron___RlRoUD",
  "closeButton": "SettingsModalLayout.module__closeButton___RlRoUD",
  "sidebarNavFooter": "SettingsModalLayout.module__sidebarNavFooter___RlRoUD",
  "desktopScrollSpacerTop": "SettingsModalLayout.module__desktopScrollSpacerTop___RlRoUD",
  "desktopScrollSpacerBottom": "SettingsModalLayout.module__desktopScrollSpacerBottom___RlRoUD",
  "sidebarSubItemsWrap": "SettingsModalLayout.module__sidebarSubItemsWrap___RlRoUD",
  "sidebarSubItems": "SettingsModalLayout.module__sidebarSubItems___RlRoUD",
  "sidebarSubItem": "SettingsModalLayout.module__sidebarSubItem___RlRoUD",
  "sidebarSubItemIndicator": "SettingsModalLayout.module__sidebarSubItemIndicator___RlRoUD",
  "sidebarSubItemLabel": "SettingsModalLayout.module__sidebarSubItemLabel___RlRoUD",
  "sidebarSubItemActive": "SettingsModalLayout.module__sidebarSubItemActive___RlRoUD",
};

__webpack_require__.r(module.exports = exports);
